import { PublicService, ObserverService, ListingModalService, ContentService } from '@DavisDigital/davisdigitalfrontend.module';
import { Folder } from '@DavisDigital/interfaces';
import { ShareModalType } from '@DavisDigital/directives/modals/share-setting-modal';

class FolderCardController {

	public listingController:any;

	public folder: Folder;
	public folderType: string;
	public parentArchiveFolder:boolean = false;

	public title: string;
	public lessonCount: number;
	public folderCount: number;
	public createdDateTime: string = "";
	public url: string;
	public slatwall:any;
	public archiveFlag:boolean = false;
	
	public canEdit: boolean = false;
	public sharedBy : string = "";
	public shareText : string = "";
	
	public accountId: string;
	public superUser: boolean;
	
	//new flag added to differentiate between folders created and shared by others
	public sharedByUser:boolean = false;

	// @ngInject
	constructor(
		public $filter			: ng.IFilterService,
		public publicService	: PublicService,
		public observerService	: ObserverService,
		public contentService  : ContentService,
		public listingModalService: ListingModalService
	){}

	public $onInit = () => {
		this.mapMethodsFromFolder();
	}
	
	public onShare = () => {
		//share with class only if folder is not archived and has lessons
		let shareWithClass = this.listingController.davisAccountType != "Student" && !this.folder.archiveFlag && this.folder.calculatedLessonsCount > 0;
	    this.listingModalService.launchShareSettingModal(this.title,this.folder.folderID,'folder',"",Function,{}, shareWithClass);
	}
	
	public onExport = (type:ShareModalType = "lesson") => {
	    this.listingModalService.launchExportModal(this.folderType, this.folder.folderType_systemCode,this.title,this.folder.folderID, type);
	}
	
	public onRename = () => {
	   this.listingModalService.launchAddEditFolderModal(
	        this.folder.folderType_systemCode, 
	        this.folder.folderID,
	        this.folder.title,
	        (success) => {
	            if(success){
			        this.notifyRefreshFolders();
	            }
	        }
	   );
	}
	
	public onArchive = () => {
	    this.listingModalService.launchArchiveModal(this.title,this.folder.folderID,'folder', true, this.notifyRefreshFolders);
	}
	
	public onUnarchive = () => {
	    this.listingModalService.launchArchiveModal(this.title,this.folder.folderID,'folder', false, this.notifyRefreshFolders);
	}
	
	public onDelete = () => {
	    this.listingModalService.launchDeleteModal(
	        this.title,
	        this.folder.folderID,
	        'folder',  
	        (confirmDelete) => {
	            if(confirmDelete){
	            	if( this.sharedByUser ) {
		        		this.removeAccountAccess();
		        	} else {
		        		this.deleteFolder();
		        	}
	            }
	        },
	        'lesson', //folder-type
	        this.folderType == 'shared' ? true : false,
	    );
	}
	
		
	protected removeAccountAccess = () =>{
	    this.contentService
        .removeAccountAccessForShare(this.folder.folderID)
        .then( result => {
			if( result?.successfulActions?.length ) {
			    this.notifyRefreshFolders();
			}
		});
		//TODO: success/errors
	}
	
	
	protected deleteFolder = () =>{
	    this.contentService
        .deleteFolder(this.folder.folderID)
        .then( result => {
			if( result.successfulActions.length ) {
			    this.notifyRefreshPortfoliosAndFolders();
			}
		});
		//TODO: success/errors
	}

	private notifyRefreshFolders = () =>{
	    this.listingController.getFolders(false,true);
	}

	private notifyRefreshPortfoliosAndFolders = () => {
	    this.listingController.refreshFoldersAndPortfolios(true, true);
	}

	public mapMethodsFromFolder = () => {
		this.title = this.folder.title;
		
		if(this.folder.archiveFlag) {
			this.lessonCount = this.folder.calculatedArchiveLessonsCount;
			this.folderCount = this.folder.calculatedArchiveFoldersCount;
			
			//to handle invalid count case
			if(typeof this.folderCount == "string") {
				this.folderCount = 0;
			}
		} else {
			this.lessonCount = this.folder.calculatedLessonsCount;
		}
		
		//to handle invalid count case
		if(typeof this.lessonCount == "string") {
			this.lessonCount = 0;
		}
		
		if( this.folder.createdDateTime.trim() != ""){
			this.createdDateTime = this.$filter('date')(new Date(this.folder.createdDateTime), "MM/dd/yyyy");
		}
		
		var accountAccess = false;
		if( this.folder.hasOwnProperty('accountAccess')) {
			this.sharedBy = this.folder.accountAccess.createdByAccount.firstName+" "+this.folder.accountAccess.createdByAccount.lastName;
			
			if(this.folder.accountAccess.accountAccessType == "accountAccessWrite") {
				accountAccess = true;
			}
		}
		
		this.canEdit = ( this.folder.account_accountID === this.accountId || this.superUser ) || (accountAccess) || (this.folder.archiveFlag != false);
					   
		this.shareText = this.canEdit ? "Can Edit" : "Can View";
		
		
		this.archiveFlag = this.folder.archiveFlag;
		//set parent archive folder flag
		if(this.folder.archiveFolder_folderID.trim() != ""){
			this.parentArchiveFolder = true;
		}
		
		this.sharedByUser = this.folderType == 'shared' && this.folder?.accountAccess != undefined;
	}

}

class FolderCard {
	public restrict: string = 'E';
	public scope: boolean = true;

	public bindToController: any = {
		folder: '=',
		folderType: '=',
		listingController: '=',
		accountId:'@?',
		superUser:'=?'
	};

	public controller = FolderCardController;
	public controllerAs = 'folderCard';

	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/folder-card.html';

	public static Factory() {
		return () => new this();
	}
}

export { FolderCard, FolderCardController };
